import { useState, useRef } from 'react';

export default function useUploadImage() {
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return {
    uploadedFile,
    fileInputRef,
    handleImageChange,
    handleRemoveFile,
    setUploadedFile,
  };
}
